// removed by extract-text-webpack-plugin
module.exports = {"rightMargin":"styles__rightMargin__3Ro8i","noTopPadding":"styles__noTopPadding__3zXdC","noTopMargin":"styles__noTopMargin__2qUVW","verticalCenterChildren":"styles__verticalCenterChildren__2mU6e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfResize/styles.scss
// module id = 329
// module chunks = 0